import React, { useState } from 'react';
import SearchBar from '../../components/Atoms/SearchBar/SearchBar';
import AddPaymentGateway from './Components/AddPaymentGateway';

const PaymentGateway = () => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    country1: 'UK',
    country2: 'UK',
    selectCountry: 'UK',
    apiIntegrate: '',
    rate: '0.520'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData); 
  };



  return (
    <div className="p-6">
      <div className="flex flex-wrap items-center justify-between mb-6">
        <h1 className="text-[20px] font-[600] text-[#1D1F2C] w-full sm:w-auto mb-4 sm:mb-0">Add Payment Gateway Integration</h1>
        <button className="px-4 py-2 text-white bg-[#00811D] text-[14px] font-[500] rounded-md cursor-pointer hover:bg-[#175f27]" onClick={() => setIsConfirmModalOpen(true)}>
          Integrated API
        </button>
      </div>
      <SearchBar />

      <div className="">
        <div className="grid grid-cols-2 p-6 border-b border-l border-r gap-y-4">
          <div className="text-[#1D1F2C] text-[14px] font-[500]">Country Name</div>
          <div className="text-[#1D1F2C] text-[14px] font-[500] text-right">Uk</div>
          <div className="text-[#1D1F2C] text-[14px] font-[500]">Selected Country</div>
          <div className="text-[#1D1F2C] text-[14px] font-[500] text-right">UK</div>
          <div className="text-[#1D1F2C] text-[14px] font-[500]">API Integrate</div>
          <div className="text-[#1D1F2C] text-[14px] font-[500] text-right">XYZ</div>
        </div>
      </div>

      <AddPaymentGateway
        isOpen={isConfirmModalOpen}
        closeModal={() => setIsConfirmModalOpen(false)}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        formData={formData}
      />
    </div>
  );
};

export default PaymentGateway;
